import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    placa: null,
    carroceria: null,
    numero_motor: 0,
    numero_chasis: 0,
    numero_serie: 0,
    numero_vin: 0,
    matriculado: null,
    color_primario: null,
    color_secundario: null,
    kilometraje: 0,
    transito_id: null,
    transito_name: null,
    propietario_nombre: null,
    propietario_email: null,
    propietario_tipo_id: null,
    propietario_number_id: null,
    propietario_tel: null,
    propietario_direccion: null
};
const mutations = {
    updateField,
    updateVehiculo: (state, payload) => {
        var size = Object.keys(payload.fichatecnica.datos_vehiculo).length;
        if(size > 0){
            var {
                placa,
                carroceria,
                numero_motor,
                numero_chasis,
                numero_serie,
                numero_vin,
                matriculado,
                color_primario,
                color_secundario,
                transito_id,
                transito_name,
                propietario_nombre,
                propietario_email,
                propietario_tipo_id,
                propietario_number_id,
                propietario_tel,
                propietario_direccion,
            } = payload.fichatecnica.datos_vehiculo;
            state.placa= placa;
            state.carroceria= carroceria;
            state.numero_motor= numero_motor;
            state.numero_chasis= numero_chasis;
            state.numero_serie= numero_serie;
            state.numero_vin= numero_vin;
            state.matriculado= matriculado;
            state.color_primario= color_primario;
            state.color_secundario= color_secundario;
            state.transito_id= transito_id;
            state.transito_name= transito_name;
            state.propietario_nombre= propietario_nombre;
            state.propietario_email= propietario_email;
            state.propietario_tipo_id= propietario_tipo_id;
            state.propietario_number_id= propietario_number_id;
            state.propietario_tel= propietario_tel;
            state.propietario_direccion= propietario_direccion;  
            state.kilometraje = payload.fichatecnica.kilometraje;
        }else{
            state.kilometraje = payload.fichatecnica.kilometraje;
            state.propietario_nombre = payload.clientes.nombre+' '+payload.clientes.apellido;
            state.propietario_email = payload.clientes.email;
            state.propietario_tel = payload.clientes.celular;
        }
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
